import { appURL } from "src/Connectors/_main";

const useGetCarRoute = async (token: string) => {
    const response = await fetch(`${appURL}/gpstracking-rest-api/v1/current-location?hash=${encodeURIComponent(token)}`);
    if (!response.ok) {
        console.error("Failed to fetch car route");
        return null
    }
    return response.json()
}

export {
    useGetCarRoute,
}


// WEBPACK FOOTER //
// ./src/Modules/CarRouteViewer/Api/Services/useGetCarRoute.ts